import { Card, Field, inputCls } from "./fields";

const SOCIALS = [
  ["instagram", "إنستغرام"],
  ["facebook", "فيسبوك"],
  ["tiktok", "تيك توك"],
];

export default function ContactTab({ draft, update }) {
  if (!draft) return null;
  const socialUrl = (platform) => draft.footer.social?.find((s) => s.platform === platform)?.url || "";
  const setSocialUrl = (platform, url) => {
    const others = draft.footer.social.filter((s) => s.platform !== platform);
    update("footer", "social", [...others, { platform, url }]);
  };

  return (
    <div className="grid gap-6 lg:grid-cols-2">
      <Card title="إعدادات واتساب" testid="admin-card-whatsapp">
        <Field label="رقم واتساب (بصيغة دولية، مثال: ‎+222 00 00 00 00)">
          <input dir="ltr" className={`${inputCls} text-left`} data-testid="admin-whatsapp-number" value={draft.contact.whatsappNumber} onChange={(e) => update("contact", "whatsappNumber", e.target.value)} />
        </Field>
        <Field label="الرسالة الافتراضية (للزوار)">
          <textarea rows={2} className={inputCls} data-testid="admin-whatsapp-message" value={draft.contact.whatsappMessage} onChange={(e) => update("contact", "whatsappMessage", e.target.value)} />
        </Field>
        <Field label="الرسالة الافتراضية (لأصحاب الصالونات)">
          <textarea rows={2} className={inputCls} data-testid="admin-owner-message" value={draft.contact.ownerMessage} onChange={(e) => update("contact", "ownerMessage", e.target.value)} />
        </Field>
        <p className="rounded-xl bg-gold/10 px-4 py-3 text-xs leading-relaxed text-gold-dark">
          كل أزرار واتساب في الموقع تستخدم هذا الرقم والرسالة تلقائياً.
        </p>
      </Card>

      <Card title="نصوص قسم التواصل" testid="admin-card-contact-texts">
        <div className="grid gap-4 sm:grid-cols-2">
          <Field label="العنوان الصغير">
            <input className={inputCls} data-testid="admin-contact-eyebrow" value={draft.contact.eyebrow} onChange={(e) => update("contact", "eyebrow", e.target.value)} />
          </Field>
          <Field label="العنوان الرئيسي">
            <input className={inputCls} data-testid="admin-contact-title" value={draft.contact.title} onChange={(e) => update("contact", "title", e.target.value)} />
          </Field>
        </div>
        <Field label="الوصف">
          <input className={inputCls} data-testid="admin-contact-subtitle" value={draft.contact.subtitle} onChange={(e) => update("contact", "subtitle", e.target.value)} />
        </Field>
        <Field label="نص زر واتساب">
          <input className={inputCls} data-testid="admin-contact-button" value={draft.contact.whatsappButton} onChange={(e) => update("contact", "whatsappButton", e.target.value)} />
        </Field>
        <Field label="عنوان نموذج الاستفسار">
          <input className={inputCls} data-testid="admin-contact-form-title" value={draft.contact.formTitle} onChange={(e) => update("contact", "formTitle", e.target.value)} />
        </Field>
      </Card>

      <Card title="روابط التواصل الاجتماعي" testid="admin-card-social">
        {SOCIALS.map(([platform, label]) => (
          <Field key={platform} label={label}>
            <input
              dir="ltr"
              className={`${inputCls} text-left`}
              placeholder="https://…"
              data-testid={`admin-social-${platform}`}
              value={socialUrl(platform)}
              onChange={(e) => setSocialUrl(platform, e.target.value)}
            />
          </Field>
        ))}
        <p className="text-xs text-moss">اترك الرابط كما هو (#) ليظهر كعنصر مؤقت في التذييل.</p>
      </Card>
    </div>
  );
}
